import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IApplicationPhoneVersion } from '../../../../core/interfaces/voice/application-phone-version';
import { AutopilotService } from '../../../../core/services/autopilot/autopilot.service';
import { ApplicationPhoneService } from '../../../../core/services/voice/application-phone.service';

@Component({
  selector: 'app-translate-all-info',
  templateUrl: './translate-all-info.component.html',
  styleUrl: './translate-all-info.component.scss',
  providers: [AutopilotService, ApplicationPhoneService]
})
export class TranslateAllInfoComponent implements OnInit {

  public type: TranslateType = TranslateType.None;

  //Common
  public requestId: any = null;
  public requestName: string = "";
  public languageNames: string[] = [];
  public loading: boolean = false;

  //Bots
  public defaultLanguage: string = "";
  public botId: any = '';
  public isModule: boolean = false;
  public hasVersion: boolean = false;
  public phoneVersions: IApplicationPhoneVersion[] = [];
  public phoneVersion = new UntypedFormControl(null);

  constructor(private dialogRef: MatDialogRef<TranslateAllInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private autopilotService: AutopilotService,
    private applicationPhoneService: ApplicationPhoneService) {

    if (data == null) {
      return;
    }

    this.type = data.type;

    this.requestId = data.requestId;
    this.requestName = data.requestName;
    this.languageNames = data.languageNames;

    this.defaultLanguage = data.defaultLanguage;
    this.botId = data.botId;
    this.isModule = data.isModule;

    this.phoneVersions = data.phoneVersions;
    this.phoneVersions = data.phoneVersions;
    this.hasVersion = this.phoneVersions != null && this.phoneVersions.findIndex(x=>x.version!=1) >= 0;

    if (this.hasVersion) {
      if (this.phoneVersions.length == 1) {
        this.phoneVersion.patchValue(this.phoneVersions[0].version);
      }
      this.phoneVersion.setValidators(Validators.required);
      this.phoneVersion.updateValueAndValidity();
    }
    else {
      this.phoneVersion.clearValidators();
      this.phoneVersion.updateValueAndValidity();
    }
  }

  ngOnInit() {
    this.phoneVersion.valueChanges.subscribe(value => {
      let version = this.phoneVersions.find(x => x.version == value);
      if (version != null) {
        this.languageNames = version.languageNames;
      }
    })
  }

  cancel() {
    this.dialogRef.close(null);
  }

  translate() {
    this.loading = true;

    if (this.type == TranslateType.Autopilot) {
      this.handleAutopilotTranslation();
    }

    if (this.type == TranslateType.ApplicationPhone) {
      this.handleApplicationPhoneTranslation();
    }
  }

  handleAutopilotTranslation() {
    const id = this.requestId != null ? this.requestId : '';

    this.autopilotService.translate(this.botId, id).subscribe(response => {
      this.dialogRef.close(response);
    });
  }

  handleApplicationPhoneTranslation() {
    if (this.isModule==true) {
      this.applicationPhoneService.translateApplicationPhoneModule(this.requestId).subscribe(response => {
        this.dialogRef.close(response);
      });
    }
    else {
      this.applicationPhoneService.translateApplicationPhone(this.requestId, this.phoneVersion.value).subscribe(response => {
        this.dialogRef.close({success:response, version:this.phoneVersion.value});
      });
    }
  }
}

export enum TranslateType {
  None = 'None',
  Autopilot = 'Autopilot',
  ApplicationPhone = 'ApplicationPhone'
}
